import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { ORDER_METHODS } from '../../../services/exports/Constants';
import { StoreInterface } from '../../../store/types';

interface Props {
  className?: string;
}

/** "Pay in cash at the counter." under the cash option of a table order: the guest walks there to pay. */
export default function CashTableNote({ className }: Props) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:OrderType:TableOrdering' });
  const isTableOrder =
    useSelector((state: StoreInterface) => state.order.cached_order?.method) === ORDER_METHODS.ON_SITE;

  if (!isTableOrder) {
    return null;
  }

  return (
    <p className={classnames('text-sm mt-xs text-muted-foreground', className)} data-test="cash-table-note">
      {t('cash_note')}
    </p>
  );
}
